import { fetchCurrentsong } from './fetchCurrentsong';
import { fetchIcestats } from './fetchIcestats';
import { fetchIcy } from './fetchIcy';
import { fetchOgg } from './fetchOgg';
import { fetchSevenHTML } from './fetchSevenHTML';
import { fetchStats } from './fetchStats';

// Фетчеры расположены в порядке убывания доступности
export const metadataFetchers = {
  icy: fetchIcy,
  ogg: fetchOgg,
  icestats: fetchIcestats,
  currentsong: fetchCurrentsong,
  stats: fetchStats,
  '7html': fetchSevenHTML
} as const;

export type MetadataFetcherType = keyof typeof metadataFetchers;
